import { effect, inject, Injectable } from '@angular/core';
import { AuthUser } from '../domainTypes/auth';
import { AuthService } from './auth.service';
import { environment } from '../../environments/environment';

declare const FS: (
    action: string,
    options: {
        uid: string;
        properties?: Record<string, unknown>;
    }
) => void;

@Injectable({
    providedIn: 'root',
})
export class FullStoryService {
    private readonly authService = inject(AuthService);
    private identifiedUid: string | null = null;

    identifyUser$ = effect(() => {
        const authState = this.authService.state();

        if (authState.status !== 'authenticated' || !authState.user) {
            return;
        }

        const uid = authState.user.user_id.toString();
        if (this.identifiedUid === uid) {
            return;
        }

        this.identifiedUid = uid;
        this.identifyUser(authState.user);
    });

    private identifyUser(user: AuthUser) {
        if (!environment.production && (environment.environmentType as string) !== 'feature1') {
            console.log('Skipping FullStory identify call in development mode');
            return;
        }

        if (typeof FS === 'undefined') {
            return;
        }

        FS('setIdentity', {
            uid: user.user_id.toString(),
            properties: {
                displayName: [user.first_name, user.last_name].filter(Boolean).join(' ') || user.email,
                email: user.email,
                workspaceName: user.workspace_name ?? '',
                companyName: user.company_name ?? '',
                environment: environment.environmentType,
            },
        });

        console.log('FullStory identify call made for user:', {
            uid: user.user_id.toString(),
            displayName: [user.first_name, user.last_name].filter(Boolean).join(' ') || user.email,
            email: user.email,
            workspaceName: user.workspace_name ?? '',
            companyName: user.company_name ?? '',
            environment: environment.environmentType,
        });
    }
}
